import { CellContext, Row, createColumnHelper } from '@tanstack/react-table'
import TableBase, { Pagination } from './TableBase'

export type TableColumnConfiguration<T> = {
    id: keyof T & string
    title: string | React.ReactNode
    shouldSort: boolean
    customRender?: (info: CellContext<T, any>) => React.ReactNode
    style?: React.CSSProperties
    filter?: {
        label: string
        filterPortalId?: string
    }
}

type Props<T> = {
    columnConfiguration: Array<TableColumnConfiguration<T>>
    tableData: T[]
    pagination?: Pagination
    rowClass?: string
    headerClass?: string
    columnClass?: string
    getRowCanExpand?: (row: Row<T>) => boolean
    renderSubComponent?: any
}

function Table<T>({ columnConfiguration, tableData, pagination, rowClass, headerClass, columnClass, getRowCanExpand, renderSubComponent }: Props<T>) {
    const columnHelper = createColumnHelper<T>()

    const columns = columnConfiguration.map((item) => {
        return columnHelper.accessor(item.id as any, {
            header: () => <span>{item.title}</span>,
            cell: (info) => (item.customRender ? item.customRender(info) : <span>{info.getValue() as any}</span>),
            meta: {
                style: item.style,
                filter: item.filter,
            },
        })
    })

    return (
        <TableBase
            columns={columns}
            tableData={tableData}
            pagination={pagination}
            rowClass={rowClass}
            headerClass={headerClass}
            columnClass={columnClass}
            getRowCanExpand={getRowCanExpand}
            renderSubComponent={renderSubComponent}
        />
    )
}

export default Table
